import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SponsorResponse} from '../../models/response.module';
import {Router} from '@angular/router';

@Component({
  selector: 'app-sponsor-card',
  standalone: false,
  templateUrl: './sponsor-card.html',
  styleUrl: './sponsor-card.css'
})
export class SponsorCard {
  @Input() sponsor: SponsorResponse
  @Output() editSponsorClick = new EventEmitter<SponsorResponse>();
  @Output() deleteSponsorClick = new EventEmitter<SponsorResponse>();

  constructor(private router: Router) {
  }

  goToSponsor() {
    // Navigate to sponsor details if needed
  }

  emitEditSponsorClick() {
    console.log("Emitting edit sponsor click for sponsor:", this.sponsor);
    this.editSponsorClick.emit(this.sponsor);
  }

  emitDeleteSponsorClick() {
    console.log("Emitting delete sponsor click for sponsor:", this.sponsor);
    this.deleteSponsorClick.emit(this.sponsor);
  }
}
